import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import errorIcon from 'src/assets/icons/illustration-error.svg';
import Storage from 'src/latest/src/utils/Storage';
import { setFlashNotification } from 'src/redux/modules/flashNotification';
import { Typography } from '../../components';
import { AppConstant } from '../../constants';
import './LoggingErrorScreen.scss';

export default function LoggingErrorScreen(): JSX.Element {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useNavigate();
  const isProduction = false; // process.env.NODE_ENV !== 'development'; // update the condition as per required
  const [error, setError] = useState<Record<string, any>>({});
  const [location, setLocation] = useState<string>('');

  const CopyToClipboard = () => {
    navigator.clipboard.writeText(AppConstant.i2i.emails.support).then(() => {
      dispatch(
        setFlashNotification({
          message: t('messages.emailCopied'),
          isError: false,
          duration: 2000,
        }),
      );
    });
  };

  useEffect(() => {
    const errorStorage = JSON.parse(Storage.getItem('error') || '{}');

    if (Object.keys(errorStorage).length > 0) {
      const { err, loc } = errorStorage;

      setError(err);
      setLocation(loc);
    } else {
      history('/');
    }

    return () => Storage.removeItem('error');
  }, [history]);

  return (
    <div className="logging-error d-flex justify-content-center align-items-center w-100">
      <div className="rectangle">
        <div className="error-icon-holder">
          <img src={errorIcon} alt="error icon" />
        </div>
        <div className="error-message-container">
          {!isProduction && (
            <div>
              {(
                error?.stack?.split('@')[0]?.replace('/<', '') || location
              ).includes('Loading chunk') ? (
                <div className="logging-error__chunk mt-3">
                  <Typography>
                    {t('loggingError.refreshYourBrowserMessage')}{' '}
                    {t('loggingError.or')}{' '}
                    <a href="/resources/support/technical">
                      {t('loggingError.contactUs')}
                    </a>
                    {t('loggingError.forAssistance')}
                  </Typography>{' '}
                </div>
              ) : (
                <React.Fragment>
                  <div
                    contentEditable={true}
                    className="logging-error__code mt-3 ms-3 me-3"
                  >
                    <code>
                      {location ? JSON.stringify(error) : error.message}
                    </code>
                    {location ? <br /> : '@'}
                    <code>
                      {error?.stack?.split('@')[0]?.replace('/<', '') ||
                        location}
                    </code>
                  </div>
                </React.Fragment>
              )}
            </div>
          )}
          {isProduction && (
            <div className="error-message">{t('loggingError.prodMessage')}</div>
          )}
        </div>
        <div className="contact-us">
          <div className="rectangle-card">
            <div className="content-holder" onClick={CopyToClipboard}>
              <FontAwesomeIcon className="icon-email" icon={faEnvelope} />
              <div className="support-email">{AppConstant.i2i.emails.support}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
